import {
  ReactElement,
  HTMLAttributes,
} from "react";
import { Footer, Header, HeaderResponsive } from "../layout";

interface Props extends HTMLAttributes<HTMLElement> {
  children: any;
  title: string;
}
export function Layout({ children, title }: Props): ReactElement {
  return (
    <div className="layout">

      <div className=" layout-content">
        <Header title={title} />
        <div className="layout-content-padding">
          <div className="hide-mobile">
            <HeaderResponsive />
          </div>
          <div className="children">
           {children}
           <Footer/>

          {/* <div className="menu-list">
              <Link className="item" to="https://core.karamad.net/">سامانه بیمه ای </Link>
              <Link className="item" to="https://mlm.karamad.net/">سامانه نمایندگان </Link>
              <Link className="item" to="https://portal.karamad.net/">سامانه شرکتی </Link>
          </div>
          <div className="copyright">
            Develop with <CiHeart /> by <span className="colorful"> Karamad Team </span> .
          </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}


export default Layout;
